var _path, _path2, _path3, _path4, _circle, _clipPath, _filter, _clipPath2, _filter2, _clipPath3, _filter3, _clipPath4, _filter4, _clipPath5, _filter5, _clipPath6, _filter6, _clipPath7, _filter7, _clipPath8, _filter8, _clipPath9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpeingHours(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F0F6FE",
    style: {
      fill: "#F0F6FE",
      fill: "color(display-p3 0.9412 0.9647 0.9961)",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 28H47V42C47 43.1046 46.1046 44 45 44H19C17.8954 44 17 43.1046 17 42V28Z",
    fill: "url(#paint0_linear_6764_129079)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 22C17 20.8954 17.8954 20 19 20H45C46.1046 20 47 20.8954 47 22V28H17V22Z",
    fill: "url(#paint1_linear_6764_129079)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17C20 16.4477 20.4477 16 21 16H24C24.5523 16 25 16.4477 25 17V20H20V17Z",
    fill: "url(#paint2_linear_6764_129079)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17C39 16.4477 39.4477 16 40 16H43C43.5523 16 44 16.4477 44 17V20H39V17Z",
    fill: "url(#paint3_linear_6764_129079)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 28.8501,
    y: 27.8516,
    width: 28.2998,
    height: 28.2969
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3px)",
      clipPath: "url(#bgblur_0_6764_129079_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 6,
    cx: 43,
    cy: 42,
    r: 8,
    fill: "url(#paint4_linear_6764_129079)",
    stroke: "url(#paint5_linear_6764_129079)",
    strokeOpacity: 0.17,
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 37,
    y: 31,
    width: 12,
    height: 16
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_1_6764_129079_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6764_129079)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 36,
    width: 2,
    height: 6,
    rx: 1,
    fill: "white",
    fillOpacity: 0.6,
    style: {
      fill: "white",
      fillOpacity: 0.6
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 37.4143,
    y: 36.4141,
    width: 14.8284,
    height: 14.8281
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_2_6764_129079_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6764_129079)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42.4141,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-45 42 42.4141)",
    fill: "white",
    fillOpacity: 0.6,
    style: {
      fill: "white",
      fillOpacity: 0.6
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 36,
    y: 35,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_3_6764_129079_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6764_129079)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 42,
    r: 2,
    fill: "white",
    fillOpacity: 0.7,
    style: {
      fill: "white",
      fillOpacity: 0.7
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 16,
    y: 25,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_4_6764_129079_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_6764_129079)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 30,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white",
    fillOpacity: 0.8,
    style: {
      fill: "white",
      fillOpacity: 0.8
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 22,
    y: 25,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_5_6764_129079_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_6764_129079)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 30,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white",
    fillOpacity: 0.8,
    style: {
      fill: "white",
      fillOpacity: 0.8
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 28,
    y: 25,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_6_6764_129079_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_6764_129079)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 30,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white",
    fillOpacity: 0.4,
    style: {
      fill: "white",
      fillOpacity: 0.4
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 16,
    y: 31,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_7_6764_129079_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_6764_129079)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 36,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white",
    fillOpacity: 0.4,
    style: {
      fill: "white",
      fillOpacity: 0.4
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 22,
    y: 31,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(#bgblur_8_6764_129079_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_6764_129079)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 36,
    width: 4,
    height: 4,
    rx: 1,
    fill: "white",
    fillOpacity: 0.8,
    style: {
      fill: "white",
      fillOpacity: 0.8
    },
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_6764_129079_clip_path",
    transform: "translate(-28.8501 -27.8516)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 42,
    r: 8
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6764_129079",
    x: 37,
    y: 31,
    width: 12,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129079",
    result: "shape"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_6764_129079_clip_path",
    transform: "translate(-37 -31)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 36,
    width: 2,
    height: 6,
    rx: 1
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6764_129079",
    x: 37.4143,
    y: 36.4141,
    width: 14.8284,
    height: 14.8281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129079",
    result: "shape"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_6764_129079_clip_path",
    transform: "translate(-37.4143 -36.4141)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42.4141,
    width: 2,
    height: 6,
    rx: 1,
    transform: "rotate(-45 42 42.4141)"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6764_129079",
    x: 36,
    y: 35,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129079",
    result: "shape"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_6764_129079_clip_path",
    transform: "translate(-36 -35)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 42,
    r: 2
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_6764_129079",
    x: 16,
    y: 25,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129079",
    result: "shape"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_4_6764_129079_clip_path",
    transform: "translate(-16 -25)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 30,
    width: 4,
    height: 4,
    rx: 1
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_6764_129079",
    x: 22,
    y: 25,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129079",
    result: "shape"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_5_6764_129079_clip_path",
    transform: "translate(-22 -25)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 30,
    width: 4,
    height: 4,
    rx: 1
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_6764_129079",
    x: 28,
    y: 25,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129079",
    result: "shape"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_6_6764_129079_clip_path",
    transform: "translate(-28 -25)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 30,
    width: 4,
    height: 4,
    rx: 1
  }))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_6764_129079",
    x: 16,
    y: 31,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129079",
    result: "shape"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_7_6764_129079_clip_path",
    transform: "translate(-16 -31)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 36,
    width: 4,
    height: 4,
    rx: 1
  }))), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_6764_129079",
    x: 22,
    y: 31,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.249202 0 0 0 0 0.431605 0 0 0 0 0.897743 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6764_129079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6764_129079",
    result: "shape"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_8_6764_129079_clip_path",
    transform: "translate(-22 -31)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 36,
    width: 4,
    height: 4,
    rx: 1
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6764_129079",
    x1: 24.5,
    y1: 29,
    x2: 44.1812,
    y2: 31.1408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B72FF",
    style: {
      stopColor: "#3B72FF",
      stopColor: "color(display-p3 0.2326 0.4489 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2361FF",
    style: {
      stopColor: "#2361FF",
      stopColor: "color(display-p3 0.1376 0.3791 0.9982)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6764_129079",
    x1: 24.5,
    y1: 24,
    x2: 28.7156,
    y2: 35.6285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C95FF",
    style: {
      stopColor: "#6C95FF",
      stopColor: "color(display-p3 0.4219 0.5846 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2763FF",
    style: {
      stopColor: "#2763FF",
      stopColor: "color(display-p3 0.1531 0.3893 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6764_129079",
    x1: 22.5,
    y1: 16,
    x2: 22.3593,
    y2: 19.4618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5988FF",
    style: {
      stopColor: "#5988FF",
      stopColor: "color(display-p3 0.3504 0.5334 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336DFF",
    style: {
      stopColor: "#336DFF",
      stopColor: "color(display-p3 0.1994 0.4261 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6764_129079",
    x1: 41.5,
    y1: 16,
    x2: 41.3593,
    y2: 19.4618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5988FF",
    style: {
      stopColor: "#5988FF",
      stopColor: "color(display-p3 0.3504 0.5334 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336DFF",
    style: {
      stopColor: "#336DFF",
      stopColor: "color(display-p3 0.1994 0.4261 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6764_129079",
    x1: 38,
    y1: 34,
    x2: 43.892,
    y2: 50.0342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5,
    style: {
      stopColor: "white",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D5BB9",
    stopOpacity: 0.4,
    style: {
      stopColor: "#2D5BB9",
      stopColor: "color(display-p3 0.1753 0.3584 0.7245)",
      stopOpacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6764_129079",
    x1: 36.5,
    y1: 34,
    x2: 45.2073,
    y2: 52.8123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFDEFF",
    style: {
      stopColor: "#CFDEFF",
      stopColor: "color(display-p3 0.8134 0.8696 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004DFF",
    style: {
      stopColor: "#004DFF",
      stopColor: "color(display-p3 0.0010 0.3017 1.0000)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeingHours);
export default __webpack_public_path__ + "static/media/opeing_hours.9c2d25c0ae1c9311f707b156fcd6cbc4.svg";
export { ForwardRef as ReactComponent };